import { render, staticRenderFns } from "./CustomerGroupTable.vue?vue&type=template&id=f1980928&scoped=true"
import script from "./CustomerGroupTable.vue?vue&type=script&lang=js"
export * from "./CustomerGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1980928",
  null
  
)

export default component.exports